export default __webpack_public_path__ + "static/media/driver.bc4ee2cf.jpeg";